export const TRIGGER_TIMINGS_BY_POSITION = {
  1: [9],
  2: [10, 5, 6, 7],
  3: [9],
  4: [9],
  5: [10],
  6: [10],
  7: [9]
}

export const getAllowedTriggerTimingValues = (position) => {
  return TRIGGER_TIMINGS_BY_POSITION[Number(position)] || []
}

export const buildTriggerSceneOptions = (
  positionOptions = [],
  actionOptions = []
) => {
  return positionOptions.map((position) => {
    const positionValue = Number(position.dictValue)
    const children = actionOptions
      .filter((action) =>
        getAllowedTriggerTimingValues(positionValue).includes(
          Number(action.dictValue)
        )
      )
      .map((action) => ({
        value: Number(action.dictValue),
        label: action.dictName
      }))

    return {
      value: positionValue,
      label: position.dictName,
      children
    }
  })
}
